/*
 * Copyright (c) 2000-2022 TeamDev. All rights reserved.
 * TeamDev PROPRIETARY and CONFIDENTIAL.
 * Use is subject to license terms.
 */

import VueI18n from 'vue-i18n';
import i18n from '@/shell/i18n/i18n';
// @ts-expect-error
import {CommercialLicenseRevocationReason} from '@proto/teamdev/licensing/values_pb';

/**
 * Utilities for the `CommercialLicenseRevocationReason` type.
 */
export class CommercialLicenseRevocationReasons {

  /**
   * Returns a human-readable description of the provided revocation reason.
   */
  static format(value: CommercialLicenseRevocationReason): string {
    const key =
        value.getLicenseOveruse()             ? 'licenseOveruse' :
        value.getLicenseIllegalDistribution() ? 'licenseIllegalDistribution' :
        value.getLicenseInvalidated()         ? 'licenseMisuse' :
        value.getRefund()                     ? 'refund' :
        value.getOther()                      ? 'other' :
          (() => {
            throw new Error('Invalid CommercialLicenseRevocationReason state');
          })();

    return this.t(
        key,
        value.getOther()
            ? {description: value.getOther().getDescription()}
            : undefined
    );
  }

  private static t(relativeKey: string | number,
                   values?: VueI18n.Values): string {
    return i18n.t(
        `lserv-app.shell.model.teamdev.licensing.q.commercial.CommercialLicenseRevocationReason.${relativeKey}`,
        values) as string;
  }
}
